import { CodeBook, UploadFile } from "@king-ict/eupisi-ui/models";

import QuestionnaireQuestionGroupDto from "./InitialConversationQuestionGroup";
import { PersonDetails } from "./PersonDetails";
import { RegistrationFormStatus } from "./RegistrationFormStatus";
import RequestStatus from "./RequestStatusEnum";
import { RequestStep } from "./RequestStep";
import RequestTypeEnum from "./RequestTypeEnum";
import InstitutionProgram from "../Institution/InstitutionProgram";
import ParentNumberEnum from "../Person/ParentNumberEnum";
import RequestAnswer from "../Questionnaire/RequestAnswer";
import { Attachment } from "../Shared/Attachment";
import { HierarchicalCodeBook } from "../Shared/HierarchicalCodeBook";

export default interface Request {
  id?: number;
  uId: string;
  code?: string;
  requestUID?: string;
  statusId: RequestStatus | number;
  parentNumberId: ParentNumberEnum;
  applicantParentDetails: PersonDetails;
  otherParentDetails: PersonDetails;
  childDetails: PersonDetails;
  type: RequestTypeEnum;
  step: RequestStep;
  subStep?: number | null;
  parentRemark: string | null;

  applicantParent?: Person;
  child?: Person;
  schoolYearCode?: string;
  schoolCandidateId?: number | null;
  institutionCommitteeId?: number | null;
  countyCommitteeId?: number | null;
  countyId?: number | null;

  institutionOutsideResidenceReasonId?: number;
  initialConversationQuestionGroups: QuestionnaireQuestionGroupDto[];

  questionnaireAnswers: RequestAnswer[];
  otherInstitutionSelect: CodeBook[];
  isInstitutionOutsideResidence: boolean;
  schoolYearId: number;

  institutionId: number;
  outsideEnrollmentAreaInstitutionId?: number;
  institutionProgramId?: number;
  institutionProgram?: InstitutionProgram;
  isPrimaryInstitutionCommercialProgramSelected: boolean;
  isSecondaryInstitutionCommercialProgramSelected: boolean;
  commercialProgramId: number | null;
  isOutsideEnrollmentArea: boolean;
  outsideEnrollmentAreaInstitutionProgramId?: number | null;
  outsideEnrollmentAreaInstitutionProgram?: InstitutionProgram | null;
  institutionChangeReason?: InstitutionChangeReason | null;
  institutionChangeReasonOther?: string | null;
  createdByAdmin: boolean;
  createdByAppUserId?: number | null;
  outsideEnrollmentAreaCommercialProgramId: number | null;
  mandatoryForeignLanguages?: HierarchicalCodeBook[] | null;
  electiveSubjects?: HierarchicalCodeBook[] | null;
  languageSchoolingModels?: HierarchicalCodeBook[] | null;
  foreignLanguages?: HierarchicalCodeBook[] | null;

  childUploadFiles?: UploadFile[] | null;
  childAttachments?: Attachment[];
  educationalRehabilitationUploadFiles?: UploadFile[] | null;
  educationalRehabilitationAttachments?: Attachment[];
  medicalUploadFiles?: UploadFile[] | null;
  medicalAttachments?: Attachment[];
  otherUploadFiles?: UploadFile[] | null;
  otherAttachments?: Attachment[];
  parentUploadFiles?: UploadFile[] | null;
  parentAttachments?: Attachment[];
  psychologyUploadFiles?: UploadFile[] | null;
  psychologyAttachments?: Attachment[];
  psychophysicalConditionDecisionUploadFiles?: UploadFile[] | null;
  psychophysicalConditionDecisionAttachments?: Attachment[];
  uniqueBodyOfExpertiseUploadFiles?: UploadFile[] | null;
  uniqueBodyOfExpertiseAttachments?: Attachment[];
  subsequentUploadFiles?: UploadFile[] | null;
  subsequentAttachments?: Attachment[];
  registrationFormStatus?: RegistrationFormStatus;

  questionnaire?: RequestAnswerDto[] | null;
  suggestedEnrollmentOutsideEnrollmentArea?: boolean;
  approvedEnrollmentOutsideEnrollmentArea?: boolean;
  outsideEnrollmentAreaStatus?: OutsideEnrollmentAreaStatusEnum | null;
  languageCourseDecisionStatus?: LanguageCourseDecisionStatusEnum | null;
  enrollmentInstitutionId?: number | null;
  synchronizationStatus?: SynchronizationStatusEnum | null;
  showCancelButton?: boolean;
}

export const RequestInitial: Request = {
  uId: "",
  statusId: {} as RequestStatus,
  parentNumberId: 2,
  applicantParentDetails: {} as PersonDetails,
  otherParentDetails: {} as PersonDetails,
  childDetails: {} as PersonDetails,
  initialConversationQuestionGroups: [],
  questionnaireAnswers: [],
  createdByAdmin: false,
  createdByAppUserId: undefined,
  type: RequestTypeEnum.RegularEnrollment,
  institutionOutsideResidenceReasonId: undefined,
  step: 0,
  otherInstitutionSelect: [],
  isInstitutionOutsideResidence: false,
  schoolYearId: 0,
  institutionId: 0,
  outsideEnrollmentAreaInstitutionId: 0,
  isOutsideEnrollmentArea: false,
  isPrimaryInstitutionCommercialProgramSelected: false,
  isSecondaryInstitutionCommercialProgramSelected: false,
  commercialProgramId: null,
  outsideEnrollmentAreaCommercialProgramId: null,
  parentRemark: null,
};

export enum InstitutionChangeReason {
  ExtendedStay = 1,
  FullDayClasses,
  DevelopmentalDisabilities,
  BarrierFree,
  NationalMinorityLanguage,
  Tenancy,
  Relocation,
  FamilySituation,
  Other,
}

interface Person {
  oib: string | null;
  alternativeDocumentNumber: string | null;
  alternativeDocumentReasonId: number | null;
  alternativeDocumentTypeId: number | null;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  isEmpty: boolean;
  id: number;
}

interface RequestAnswerDto {
  id: number;
  questionId: number;
  answerId: number | null;
  answerText: string | null;
}

export enum OutsideEnrollmentAreaStatusEnum {
  First = 1,
  Second = 2,
  Third = 3,
}

export enum LanguageCourseDecisionStatusEnum {
  First = 1,
  Second = 2,
  Third = 3,
}

export enum SynchronizationStatusEnum {
  First = 1,
  Second = 2,
  Third = 3,
}
